<ng-container *ngIf="{ hasAccounts: !!invitedAccounts?.length, hasEvents: !!invitedToEvents.length } as vars">
  <div class="pending" *ngIf="vars.hasAccounts">
    <div *ngFor="let acc of invitedAccounts; index as idx;trackBy: trackById">
      <div class="invited_by" *ngIf="acc.invite_sender as sender">
        <photo [data]="sender"></photo>
        <div class="name">{{sender?.firstName + ' ' + sender?.lastName}} invited you to an account as {{ acc.invited_as_role }}</div>
      </div>
      <div class="invited_by" *ngIf="!acc.invite_sender">
        <div class="name">You are invited to an account as {{ acc.invited_as_role }}</div>
      </div>
      <div class="pending_event account_invite" [ngClass]="{processing:accountService.processing[acc.id]}">
        <div class="header">
          <photo [data]="acc" [size]="36"></photo>
          <b class="name">{{acc.title}}</b>
        </div>
        <div style="flex:1;"></div>
        <div class="btns" *ngIf="acc.is_invited">
          <button mat-button (click)="accountService.decline(acc)">Decline</button>
          <button mat-button color="primary" (click)="accountService.accept(acc)">Accept</button>
        </div>
        <div class="accepted-invitation" *ngIf="!acc.is_invited">Accepted!</div>
      </div>
    </div>
  </div>
  <div class="divider" *ngIf="vars.hasAccounts && vars.hasEvents" ></div>
  <div class="pending" *ngIf="vars.hasEvents" [@drop]="!vars.hasEvents ? 'collapse' : 'expand'">
    <div [@drop]="eventService.recentlyDeclined.has(evt.eventId) ? 'collapse' : 'expand'" *ngFor="let evt of invitedToEvents; trackBy: trackByEvent">
      <div class="invited_by" *ngIf="evt.invite_sender as sender">
        <photo [data]="sender"></photo>
        <div class="name">{{sender?.firstName + ' ' + sender?.lastName}} invited you to collaborate:</div>
      </div>
      <div class="pending_event" [ngClass]="{processing:eventService.processing[evt.eventId] || eventService.eventInvitationLoadingSet.has(evt.eventId)}">
        <div class="header with_date">
          <b class="name">{{evt.title}}</b>
          <div class="dates">{{eventViewService.eventDates(evt, true)}}</div>
        </div>
        <div style="flex:1;"></div>
        <div class="btns">
          <button mat-button *ngIf="!eventService.recentlyAccepted.has(evt.eventId) && !eventService.recentlyDeclined.has(evt.eventId)" (click)="declineInvitation(evt)">Decline</button>
          <button mat-button color="primary" *ngIf="!eventService.recentlyAccepted.has(evt.eventId) && !eventService.recentlyDeclined.has(evt.eventId)" (click)="eventService.accept(evt);">Accept</button>
          <div class="accepted-invitation" *ngIf="eventService.recentlyAccepted.has(evt.eventId)">Accepted! &nbsp; <span class="link" (click)="viewEvent(evt)">View Event &rsaquo;</span></div>
          <div class="declined-invitation" *ngIf="eventService.recentlyDeclined.has(evt.eventId)">You declined this event invitation.</div>
        </div>
        <mat-progress-bar mode="indeterminate" *ngIf="eventService.processing[evt.eventId]"></mat-progress-bar>
      </div>
    </div>
  </div>
</ng-container>